




// // import React, { useState } from 'react';
// // import {
// //     Dialog,
// //     DialogTitle,
// //     DialogContent,
// //     DialogActions,
// //     IconButton,
// //     Button,
// //     Box,
// //     Typography,
// //     Grid,
// // } from '@mui/material';
// // import { Close as CloseIcon } from '@mui/icons-material';
// // import { Formik, Form } from 'formik';

// // import CustomInputLogin from '../../../Components/CustomInputLogin/CustomInputLogin';
// // // import '../../ContentManagement/Home/Modal/BannerInputGetModal.css'; // Import external CSS
// // import "../../ContentManagement/Home/Modal/BannerinputGetModal.css"

// // import { MdCancel } from "react-icons/md";
// // import * as Yup from 'yup';

// // import FileUploadComponent from '../../../Components/FileUploadComponent/FileUploadComponent';
// // import ActiveInactiveRadio from '../../../Components/ActiveInactiveRadio/ActiveInactiveRadio';
// // import CustoDropDownRegister from '../../../Components/CustomDropDown/CustoDropDownRegister';
// // import CustomDateInput from '../../../Components/CustomDate/CustomDateInput';



// // const UserReferralSchemeModal = ({ open, onClose, setSubmittedValues, submittedValues }) => {
// //     const [uploadedFile, setUploadedFile] = useState(null);

// //     return (
// //         <Dialog
// //             open={open}
// //             onClose={onClose}
// //             fullWidth
// //             maxWidth="md"
// //             className="custom-dialog"
// //             sx={{
// //                 // maxWidth: "600px",
// //                 // margin: "auto",
// //                 "& .MuiPaper-root": {
// //                     borderRadius: "14px", // Target the Paper component
// //                 },
// //             }}
// //         >
// //             <Box sx={{ position: 'relative' }}>
// //                 <Box className="dialog-heading">
// //                     <IconButton
// //                         aria-label="Close"
// //                         onClick={onClose}
// //                         sx={{ position: 'absolute', top: 8, right: 8, color: 'text.secondary' }}
// //                     >
// //                         <MdCancel />
// //                     </IconButton>
// //                     <DialogTitle className="custom-dialog-title">

// //                         <Box>
// //                             <Typography className="custom-title-text" fontSize="16px" color="white">
// //                                 Create Scheme
// //                             </Typography>
// //                         </Box>
// //                     </DialogTitle>
// //                 </Box>

// //                 <Formik
// //                     initialValues={{
// //                         title: '',
// //                         status: "active",

// //                         content: '',
// //                         image: null,
// //                     }}
// //                     validationSchema={Yup.object({
// //                         title: Yup.string().required('Title is required'),
// //                         status: Yup.string().required('Status is required'),
// //                         content: Yup.string().required('Content is required'),
// //                     })}
// //                     onSubmit={(values, { resetForm }) => {
// //                         // setSubmittedValues([...submittedValues, values]);
// //                         // console.log(values, "values")
// //                         console.log("Form values:", values);

// //                         resetForm();

// //                     }}
// //                 >
// //                     {({ handleSubmit, setFieldValue, resetForm, values }) => (
// //                         <Form onSubmit={handleSubmit}>
// //                             <DialogContent dividers >
// //                                 <Grid container spacing={4} py={2}>
// //                                     {/* Title and Subtitle on the left, Content on the right */}
// //                                     <Grid item xs={12}>
// //                                         <Grid container spacing={4}>
// //                                             <Grid item xs={12} md={4}>
// //                                                 <CustoDropDownRegister
// //                                                     important={true}

// //                                                     name="user_type"
// //                                                     label="User Type"
// //                                                     custPlaceholder="select a type"
// //                                                     options={[
// //                                                         { label: "individual", value: "individual" },
// //                                                         { label: "institutional", value: "institutional" },
// //                                                     ]}
// //                                                 />
// //                                             </Grid>
// //                                             <Grid item xs={12} md={4}>
// //                                                 <CustomInputLogin
// //                                                     label="Title"
// //                                                     name="title"
// //                                                     inputType="text"
// //                                                     custPlaceholder="Enter Title"
// //                                                 />
// //                                             </Grid>
// //                                             <Grid item xs={12} md={4}>
// //                                                 <CustomInputLogin
// //                                                     label="Reap"
// //                                                     name="reap"
// //                                                     inputType="text"
// //                                                     custPlaceholder="Enter Reap value"
// //                                                 />
// //                                             </Grid>

// //                                             <Grid item xs={12} md={4}>
// //                                                 <CustomDateInput
// //                                                     label="Start Date"
// //                                                     name="startdate"

// //                                                 />
// //                                             </Grid>
// //                                             <Grid item xs={12} md={4}>
// //                                                 <CustomDateInput
// //                                                     label="End Date"
// //                                                     name="enddate"

// //                                                 />
// //                                             </Grid>


// //                                             <Grid item xs={12} md={4}>
// //                                                 <ActiveInactiveRadio name="status"
// //                                                     value={values.status} // Ensure this is correctly passed from Formik
// //                                                     onChange={(value) => setFieldValue('status', value)}// Update the Formik state when the radio button changes
// //                                                 />
// //                                             </Grid>

// //                                         </Grid>


// //                                     </Grid>



// //                                 </Grid>

// //                                 {/* Action Buttons */}
// //                                 {/* <DialogActions> */}
// //                                 <Grid sx={{ display: "flex", justifyContent: 'end', mt: 4 }}>
// //                                     <Grid>
// //                                         <Button
// //                                             onClick={() => {
// //                                                 resetForm()
// //                                                 setUploadedFile(null)
// //                                             }}
// //                                             variant="text"
// //                                             // className="custom-clear-button"
// //                                             sx={{
// //                                                 // backgroundColor: "#C38F51",
// //                                                 textTransform: "none",
// //                                                 color: "white",
// //                                                 fontSize: "16px",
// //                                                 mr: "10px",
// //                                                 // padding: "0px 40px",
// //                                                 padding: { xs: "0px 20px", md: "0px 40px" },

// //                                                 minHeight: "40px",
// //                                                 borderRadius: "23px",
// //                                                 background: "white",
// //                                                 boxShadow: "none",
// //                                                 color: "black",
// //                                                 border: "1px solid black",
// //                                                 "&:hover": {
// //                                                     backgroundColor: "#3B4056",
// //                                                     color: "white"
// //                                                 },
// //                                             }}
// //                                         >
// //                                             Cancel
// //                                         </Button>
// //                                         <Button
// //                                             type="submit"
// //                                             variant="contained"
// //                                             // className="custom-ok-button"
// //                                             sx={{
// //                                                 // backgroundColor: "#C38F51",
// //                                                 textTransform: "none",
// //                                                 color: "white",
// //                                                 fontSize: "16px",
// //                                                 boxShadow: "none",

// //                                                 // padding: "0px 40px",
// //                                                 padding: { xs: "0px 20px", md: "0px 40px" },

// //                                                 minHeight: "40px",
// //                                                 borderRadius: "23px",
// //                                                 background: "#C38F51 0% 0% no-repeat padding-box",
// //                                                 "&:hover": {
// //                                                     backgroundColor: "#3B4056",
// //                                                     boxShadow: "none",

// //                                                 },
// //                                             }}
// //                                         >
// //                                             Submit
// //                                         </Button>
// //                                     </Grid>
// //                                 </Grid>

// //                             </DialogContent>

// //                             {/* </DialogActions> */}
// //                         </Form>
// //                     )}
// //                 </Formik>

// //             </Box>
// //         </Dialog >
// //     );
// // };

// // export default UserReferralSchemeModal;







// import React, { useState } from 'react';
// import {
//     Dialog,
//     DialogTitle,
//     DialogContent,
//     DialogActions,
//     IconButton,
//     Button,
//     Box,
//     Typography,
//     Grid,
// } from '@mui/material';
// import { Close as CloseIcon } from '@mui/icons-material';
// import { Formik, Form } from 'formik';

// import CustomInputLogin from '../../../Components/CustomInputLogin/CustomInputLogin';
// // import '../../ContentManagement/Home/Modal/BannerInputGetModal.css'; // Import external CSS
// import "../../ContentManagement/Home/Modal/BannerinputGetModal.css"

// import { MdCancel } from "react-icons/md";
// import * as Yup from 'yup';

// import FileUploadComponent from '../../../Components/FileUploadComponent/FileUploadComponent';
// import ActiveInactiveRadio from '../../../Components/ActiveInactiveRadio/ActiveInactiveRadio';
// import CustoDropDownRegister from '../../../Components/CustomDropDown/CustoDropDownRegister';
// import CustomDateInput from '../../../Components/CustomDate/CustomDateInput';
// import actions from "../../../ReduxStore/actions/index";
// import { useDispatch, useSelector } from "react-redux";
// import { toast, ToastContainer } from 'react-toastify';


// const UserReferralSchemeModal = ({ open, onClose, setSubmittedValues, submittedValues }) => {
//     const [uploadedFile, setUploadedFile] = useState(null);

//     const dispatch = useDispatch()

//     const { createTier } = useSelector(
//         (state) => state?.createTier
//     );

//     const handleSubmit = async (values, resetForm) => {
//         const data1 = {
//             data: values,
//             method: "post",
//             apiName: "createTier",
//         };

//         const responseData = await dispatch(actions.CREATETIER(data1));

//         console.log(responseData,"responseDataresponseData");


//         if (responseData?.payload?.message === "Tier created successfully.") {
//             toast.success(responseData?.payload?.message)
//             resetForm();
//             setTimeout(() => onClose(), 3000)
//         } else {
//             toast.error(responseData?.payload?.message)
//         }
//     };

//     return (
//         <Dialog
//             open={open}
//             onClose={onClose}
//             fullWidth
//             maxWidth="md"
//             className="custom-dialog"
//             sx={{
//                 // maxWidth: "600px",
//                 // margin: "auto",
//                 "& .MuiPaper-root": {
//                     borderRadius: "14px", // Target the Paper component
//                 },
//             }}
//         >
//             <ToastContainer
//                 position="top-right" // or "top-center", "bottom-left", etc.
//                 autoClose={5000} // Auto close duration in ms
//                 hideProgressBar={false} // Hide or show progress bar
//                 newestOnTop={false}
//                 closeOnClick
//                 rtl={false}
//                 pauseOnFocusLoss
//                 draggable
//                 pauseOnHover
//                 theme="dark"
//             />
//             <Box sx={{ position: 'relative' }}>
//                 <Box className="dialog-heading">
//                     <IconButton
//                         aria-label="Close"
//                         onClick={onClose}
//                         sx={{ position: 'absolute', top: 8, right: 8, color: 'text.secondary' }}
//                     >
//                         <MdCancel />
//                     </IconButton>
//                     <DialogTitle className="custom-dialog-title">

//                         <Box>
//                             <Typography className="custom-title-text" fontSize="16px" color="white">
//                                 Create Scheme
//                             </Typography>
//                         </Box>
//                     </DialogTitle>
//                 </Box>

//                 <Formik
//                     initialValues={{
//                         tier_name: '',
//                         customer_discount: '',
//                         consultant_discount: ''

//                     }}
//                     validationSchema={Yup.object({
//                         tier_name: Yup.string().required('Title is required'),
//                         customer_discount: Yup.string().required('Reap is required'),
//                         consultant_discount: Yup.string().required('Reap is required'),
//                     })}
//                     onSubmit={(values, { resetForm }) => {
//                         // setSubmittedValues([...submittedValues, values]);
//                         // console.log(values, "values")
//                         handleSubmit(values, resetForm);
//                         console.log("Form values:", values);

//                         // resetForm();

//                     }}
//                 >
//                     {({ handleSubmit, setFieldValue, resetForm, values }) => (
//                         <Form onSubmit={handleSubmit}>
//                             <DialogContent dividers >
//                                 <Grid container spacing={4} py={2}>
//                                     {/* Title and Subtitle on the left, Content on the right */}
//                                     <Grid item xs={12}>
//                                         <Grid container spacing={4}>

//                                             <Grid item xs={12} md={4}>
//                                                 <CustomInputLogin
//                                                     label="Title"
//                                                     name="tier_name"
//                                                     inputType="text"
//                                                     custPlaceholder="Enter Title"
//                                                 />
//                                             </Grid>
//                                             <Grid item xs={12} md={4}>
//                                                 <CustomInputLogin
//                                                     label="Individual Reap"
//                                                     name="customer_discount"
//                                                     inputType="text"
//                                                     custPlaceholder="Enter Reap value"
//                                                 />
//                                             </Grid>

//                                             <Grid item xs={12} md={4}>
//                                                 <CustomInputLogin
//                                                     label="Financial consultant Reap"
//                                                     name="consultant_discount"
//                                                     inputType="text"
//                                                     custPlaceholder="Enter Reap value"
//                                                 />
//                                             </Grid>


//                                         </Grid>


//                                     </Grid>



//                                 </Grid>

//                                 {/* Action Buttons */}
//                                 {/* <DialogActions> */}
//                                 <Grid sx={{ display: "flex", justifyContent: 'end', mt: 4 }}>
//                                     <Grid>
//                                         <Button
//                                             onClick={() => {
//                                                 resetForm()
//                                                 setUploadedFile(null)
//                                             }}
//                                             variant="text"
//                                             // className="custom-clear-button"
//                                             sx={{
//                                                 // backgroundColor: "#C38F51",
//                                                 textTransform: "none",
//                                                 color: "white",
//                                                 fontSize: "16px",
//                                                 mr: "10px",
//                                                 // padding: "0px 40px",
//                                                 padding: { xs: "0px 20px", md: "0px 40px" },

//                                                 minHeight: "40px",
//                                                 borderRadius: "23px",
//                                                 background: "white",
//                                                 boxShadow: "none",
//                                                 color: "black",
//                                                 border: "1px solid black",
//                                                 "&:hover": {
//                                                     backgroundColor: "#3B4056",
//                                                     color: "white"
//                                                 },
//                                             }}
//                                         >
//                                             Cancel
//                                         </Button>
//                                         <Button
//                                             type="submit"
//                                             variant="contained"
//                                             // className="custom-ok-button"
//                                             sx={{
//                                                 // backgroundColor: "#C38F51",
//                                                 textTransform: "none",
//                                                 color: "white",
//                                                 fontSize: "16px",
//                                                 boxShadow: "none",

//                                                 // padding: "0px 40px",
//                                                 padding: { xs: "0px 20px", md: "0px 40px" },

//                                                 minHeight: "40px",
//                                                 borderRadius: "23px",
//                                                 background: "#C38F51 0% 0% no-repeat padding-box",
//                                                 "&:hover": {
//                                                     backgroundColor: "#3B4056",
//                                                     boxShadow: "none",

//                                                 },
//                                             }}
//                                         >
//                                             Submit
//                                         </Button>
//                                     </Grid>
//                                 </Grid>

//                             </DialogContent>

//                             {/* </DialogActions> */}
//                         </Form>
//                     )}
//                 </Formik>

//             </Box>
//         </Dialog >
//     );
// };

// export default UserReferralSchemeModal;





// import React, { useState } from 'react';
// import {
//     Dialog,
//     DialogTitle,
//     DialogContent,
//     DialogActions,
//     IconButton,
//     Button,
//     Box,
//     Typography,
//     Grid,
// } from '@mui/material';
// import { Close as CloseIcon } from '@mui/icons-material';
// import { Formik, Form } from 'formik';

// import CustomInputLogin from '../../../Components/CustomInputLogin/CustomInputLogin';
// // import '../../ContentManagement/Home/Modal/BannerInputGetModal.css'; // Import external CSS
// import "../../ContentManagement/Home/Modal/BannerinputGetModal.css"

// import { MdCancel } from "react-icons/md";
// import * as Yup from 'yup';

// import FileUploadComponent from '../../../Components/FileUploadComponent/FileUploadComponent';
// import ActiveInactiveRadio from '../../../Components/ActiveInactiveRadio/ActiveInactiveRadio';
// import CustoDropDownRegister from '../../../Components/CustomDropDown/CustoDropDownRegister';
// import CustomDateInput from '../../../Components/CustomDate/CustomDateInput';



// const UserReferralSchemeModal = ({ open, onClose, setSubmittedValues, submittedValues }) => {
//     const [uploadedFile, setUploadedFile] = useState(null);

//     return (
//         <Dialog
//             open={open}
//             onClose={onClose}
//             fullWidth
//             maxWidth="md"
//             className="custom-dialog"
//             sx={{
//                 // maxWidth: "600px",
//                 // margin: "auto",
//                 "& .MuiPaper-root": {
//                     borderRadius: "14px", // Target the Paper component
//                 },
//             }}
//         >
//             <Box sx={{ position: 'relative' }}>
//                 <Box className="dialog-heading">
//                     <IconButton
//                         aria-label="Close"
//                         onClick={onClose}
//                         sx={{ position: 'absolute', top: 8, right: 8, color: 'text.secondary' }}
//                     >
//                         <MdCancel />
//                     </IconButton>
//                     <DialogTitle className="custom-dialog-title">

//                         <Box>
//                             <Typography className="custom-title-text" fontSize="16px" color="white">
//                                 Create Scheme
//                             </Typography>
//                         </Box>
//                     </DialogTitle>
//                 </Box>

//                 <Formik
//                     initialValues={{
//                         title: '',
//                         status: "active",

//                         content: '',
//                         image: null,
//                     }}
//                     validationSchema={Yup.object({
//                         title: Yup.string().required('Title is required'),
//                         status: Yup.string().required('Status is required'),
//                         content: Yup.string().required('Content is required'),
//                     })}
//                     onSubmit={(values, { resetForm }) => {
//                         // setSubmittedValues([...submittedValues, values]);
//                         // console.log(values, "values")
//                         console.log("Form values:", values);

//                         resetForm();

//                     }}
//                 >
//                     {({ handleSubmit, setFieldValue, resetForm, values }) => (
//                         <Form onSubmit={handleSubmit}>
//                             <DialogContent dividers >
//                                 <Grid container spacing={4} py={2}>
//                                     {/* Title and Subtitle on the left, Content on the right */}
//                                     <Grid item xs={12}>
//                                         <Grid container spacing={4}>
//                                             <Grid item xs={12} md={4}>
//                                                 <CustoDropDownRegister
//                                                     important={true}

//                                                     name="user_type"
//                                                     label="User Type"
//                                                     custPlaceholder="select a type"
//                                                     options={[
//                                                         { label: "individual", value: "individual" },
//                                                         { label: "institutional", value: "institutional" },
//                                                     ]}
//                                                 />
//                                             </Grid>
//                                             <Grid item xs={12} md={4}>
//                                                 <CustomInputLogin
//                                                     label="Title"
//                                                     name="title"
//                                                     inputType="text"
//                                                     custPlaceholder="Enter Title"
//                                                 />
//                                             </Grid>
//                                             <Grid item xs={12} md={4}>
//                                                 <CustomInputLogin
//                                                     label="Reap"
//                                                     name="reap"
//                                                     inputType="text"
//                                                     custPlaceholder="Enter Reap value"
//                                                 />
//                                             </Grid>

//                                             <Grid item xs={12} md={4}>
//                                                 <CustomDateInput
//                                                     label="Start Date"
//                                                     name="startdate"

//                                                 />
//                                             </Grid>
//                                             <Grid item xs={12} md={4}>
//                                                 <CustomDateInput
//                                                     label="End Date"
//                                                     name="enddate"

//                                                 />
//                                             </Grid>


//                                             <Grid item xs={12} md={4}>
//                                                 <ActiveInactiveRadio name="status"
//                                                     value={values.status} // Ensure this is correctly passed from Formik
//                                                     onChange={(value) => setFieldValue('status', value)}// Update the Formik state when the radio button changes
//                                                 />
//                                             </Grid>

//                                         </Grid>


//                                     </Grid>



//                                 </Grid>

//                                 {/* Action Buttons */}
//                                 {/* <DialogActions> */}
//                                 <Grid sx={{ display: "flex", justifyContent: 'end', mt: 4 }}>
//                                     <Grid>
//                                         <Button
//                                             onClick={() => {
//                                                 resetForm()
//                                                 setUploadedFile(null)
//                                             }}
//                                             variant="text"
//                                             // className="custom-clear-button"
//                                             sx={{
//                                                 // backgroundColor: "#C38F51",
//                                                 textTransform: "none",
//                                                 color: "white",
//                                                 fontSize: "16px",
//                                                 mr: "10px",
//                                                 // padding: "0px 40px",
//                                                 padding: { xs: "0px 20px", md: "0px 40px" },

//                                                 minHeight: "40px",
//                                                 borderRadius: "23px",
//                                                 background: "white",
//                                                 boxShadow: "none",
//                                                 color: "black",
//                                                 border: "1px solid black",
//                                                 "&:hover": {
//                                                     backgroundColor: "#3B4056",
//                                                     color: "white"
//                                                 },
//                                             }}
//                                         >
//                                             Cancel
//                                         </Button>
//                                         <Button
//                                             type="submit"
//                                             variant="contained"
//                                             // className="custom-ok-button"
//                                             sx={{
//                                                 // backgroundColor: "#C38F51",
//                                                 textTransform: "none",
//                                                 color: "white",
//                                                 fontSize: "16px",
//                                                 boxShadow: "none",

//                                                 // padding: "0px 40px",
//                                                 padding: { xs: "0px 20px", md: "0px 40px" },

//                                                 minHeight: "40px",
//                                                 borderRadius: "23px",
//                                                 background: "#C38F51 0% 0% no-repeat padding-box",
//                                                 "&:hover": {
//                                                     backgroundColor: "#3B4056",
//                                                     boxShadow: "none",

//                                                 },
//                                             }}
//                                         >
//                                             Submit
//                                         </Button>
//                                     </Grid>
//                                 </Grid>

//                             </DialogContent>

//                             {/* </DialogActions> */}
//                         </Form>
//                     )}
//                 </Formik>

//             </Box>
//         </Dialog >
//     );
// };

// export default UserReferralSchemeModal;







import React, { useEffect, useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    IconButton,
    Button,
    Box,
    Typography,
    Grid,
} from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import { Formik, Form } from 'formik';

import CustomInputLogin from '../../../Components/CustomInputLogin/CustomInputLogin';
// import '../../ContentManagement/Home/Modal/BannerInputGetModal.css'; // Import external CSS
import "../../ContentManagement/Home/Modal/BannerinputGetModal.css"

import { MdCancel } from "react-icons/md";
import * as Yup from 'yup';

import FileUploadComponent from '../../../Components/FileUploadComponent/FileUploadComponent';
import ActiveInactiveRadio from '../../../Components/ActiveInactiveRadio/ActiveInactiveRadio';
import CustoDropDownRegister from '../../../Components/CustomDropDown/CustoDropDownRegister';
import CustomDateInput from '../../../Components/CustomDate/CustomDateInput';
import actions from "../../../ReduxStore/actions/index";
import { useDispatch, useSelector } from "react-redux";
import { toast, ToastContainer } from 'react-toastify';
import { clearCustomerId } from "../../../ReduxStore/Slices/Operator/customerSlice";
import { clearTableGetId } from '../../../ReduxStore/Slices/TableId/TableIdGetSlice';


const UserReferralSchemeModal = ({ open, onClose, setSubmittedValues, submittedValues }) => {
    const [uploadedFile, setUploadedFile] = useState(null);


    const customerId = useSelector((state) => state.customer.customerId);

    console.log(customerId, "customerIdcustomerIdcustomerIdcustomerIdcustomerId");



    const dispatch = useDispatch()

    const [formValues, setFormValues] = useState({
        tier_name: '',
        customer_discount: '',
        consultant_discount: ''

    });

    const { createTier } = useSelector(
        (state) => state?.createTier
    );



    const { updateTier } = useSelector(
        (state) => state?.updateTier
    );

    // UPDATETIER

    const handleSubmit = async (values, resetForm) => {

        if (!customerId) {
            const data1 = {
                data: values,
                method: "post",
                apiName: "createTier",
            };

            const responseData = await dispatch(actions.CREATETIER(data1));

            console.log(responseData, "responseDataresponseData");


            if (responseData?.payload?.message === "Tier created successfully.") {
                toast.success(responseData?.payload?.message)
                resetForm();
                setTimeout(() => onClose(), 3000)
            } else {
                toast.error(responseData?.payload?.message)
            }
        }

        if (customerId) {
            const data1 = {
                data: values,
                method: "put",
                apiName: `updateTier/${customerId}`,
            };

            const updateTierresponseData = await dispatch(actions.UPDATETIER(data1));

            console.log(updateTierresponseData, "updateTierresponseData");


            if (updateTierresponseData?.payload?.message === "Tier updated successfully.") {
                toast.success(updateTierresponseData?.payload?.message)
                resetForm();
                setTimeout(() => onClose(), 1500)
                dispatch(clearCustomerId(null))
                dispatch(clearTableGetId(null))
            } else {
                toast.error(updateTierresponseData?.payload?.message)
            }
        }
    };




    // edit-----------------------------------------------

    const { getTierById } = useSelector((state) => state?.getTierById);

    console.log(customerId, "hindkdmkfmdkdmdkfmslfmkldmfa");


    console.log(getTierById?.data, "getTierByIdgetTierById");

    useEffect(() => {
        if (!open) return;
        const fetchData = async () => {
            if (customerId) {
                const data1 = { data: {}, method: "get", apiName: `getTierById/${customerId}` };
                const getTierByIdResponese = await dispatch(actions.GETTIERBYID(data1));

                console.log(getTierByIdResponese?.payload?.data, "getTierByIdResponese");


                setFormValues(

                    {
                        tier_name: getTierByIdResponese?.payload?.data?.tier_name,
                        customer_discount: getTierByIdResponese?.payload?.data?.customer_discount,
                        consultant_discount: getTierByIdResponese?.payload?.data?.consultant_discount

                    }
                )

            } else {
                setFormValues({
                    tier_name: '',
                    customer_discount: '',
                    consultant_discount: ''

                })

            }
        };
        fetchData();
    }, [dispatch, customerId]);


    return (
        <Dialog
            open={open}
            // onClose={onClose}
            fullWidth
            maxWidth="md"
            className="custom-dialog"
            sx={{
                // maxWidth: "600px",
                // margin: "auto",
                "& .MuiPaper-root": {
                    borderRadius: "14px", // Target the Paper component
                },
            }}
        >

            <Box sx={{ position: 'relative' }}>
                <Box className="dialog-heading">
                    <IconButton
                        aria-label="Close"
                        onClick={() => {
                            onClose()
                            dispatch(clearCustomerId(null))
                            dispatch(clearTableGetId(null))

                        }
                        }
                        sx={{ position: 'absolute', top: 8, right: 8, color: 'text.secondary' }}
                    >
                        <MdCancel />
                    </IconButton>
                    <DialogTitle className="custom-dialog-title">

                        <Box>
                            <Typography className="custom-title-text" fontSize="16px" color="white">
                                {customerId ? "Edit Scheme" : "Create Scheme"}
                            </Typography>
                        </Box>
                    </DialogTitle>
                </Box>

                <Formik
                    enableReinitialize

                    initialValues={formValues}
                    validationSchema={Yup.object({
                        tier_name: Yup.string().required('Title is required'),
                        customer_discount: Yup.string().required('Reap is required'),
                        consultant_discount: Yup.string().required('Reap is required'),
                    })}
                    onSubmit={(values, { resetForm }) => {
                        // setSubmittedValues([...submittedValues, values]);
                        // console.log(values, "values")
                        handleSubmit(values, resetForm);
                        console.log("Form values:", values);

                        // resetForm();

                    }}
                >
                    {({ handleSubmit, setFieldValue, resetForm, values }) => (
                        <Form onSubmit={handleSubmit}>
                            <DialogContent dividers >
                                <Grid container spacing={4} py={2}>
                                    {/* Title and Subtitle on the left, Content on the right */}
                                    <Grid item xs={12}>
                                        <Grid container spacing={4}>

                                            <Grid item xs={12} md={4}>
                                                <CustomInputLogin
                                                    label="Title"
                                                    name="tier_name"
                                                    inputType="text"
                                                    custPlaceholder="Enter Title"
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={4}>
                                                <CustomInputLogin
                                                    label="Individual Reap(grams)"
                                                    name="customer_discount"
                                                    inputType="text"
                                                    custPlaceholder="Enter Reap value"
                                                />
                                            </Grid>

                                            <Grid item xs={12} md={4}>
                                                <CustomInputLogin
                                                    label="Financial consultant Reap(grams)"
                                                    name="consultant_discount"
                                                    inputType="text"
                                                    custPlaceholder="Enter Reap value"
                                                />
                                            </Grid>


                                        </Grid>


                                    </Grid>



                                </Grid>

                                {/* Action Buttons */}
                                {/* <DialogActions> */}
                                <Grid sx={{ display: "flex", justifyContent: 'end', mt: 4 }}>
                                    <Grid>
                                        <Button
                                            onClick={() => {
                                                resetForm()
                                                setUploadedFile(null)
                                                onClose()
                                                dispatch(clearCustomerId(null))
                                                dispatch(clearTableGetId(null))


                                            }}
                                            variant="text"
                                            // className="custom-clear-button"
                                            sx={{
                                                // backgroundColor: "#C38F51",
                                                textTransform: "none",
                                                color: "white",
                                                fontSize: "16px",
                                                mr: "10px",
                                                // padding: "0px 40px",
                                                padding: { xs: "0px 20px", md: "0px 40px" },

                                                minHeight: "40px",
                                                borderRadius: "23px",
                                                background: "white",
                                                boxShadow: "none",
                                                color: "black",
                                                border: "1px solid black",
                                                "&:hover": {
                                                    backgroundColor: "#3B4056",
                                                    color: "white"
                                                },
                                            }}
                                        >
                                            Cancel
                                        </Button>
                                        <Button
                                            type="submit"
                                            variant="contained"
                                            // className="custom-ok-button"
                                            sx={{
                                                // backgroundColor: "#C38F51",
                                                textTransform: "none",
                                                color: "white",
                                                fontSize: "16px",
                                                boxShadow: "none",

                                                // padding: "0px 40px",
                                                padding: { xs: "0px 20px", md: "0px 40px" },

                                                minHeight: "40px",
                                                borderRadius: "23px",
                                                background: "#C38F51 0% 0% no-repeat padding-box",
                                                "&:hover": {
                                                    backgroundColor: "#3B4056",
                                                    boxShadow: "none",

                                                },
                                            }}
                                        >
                                            {customerId ? "Update" : "Submit"}
                                        </Button>
                                    </Grid>
                                </Grid>

                            </DialogContent>

                            {/* </DialogActions> */}
                        </Form>
                    )}
                </Formik>
                {/* <ToastContainer
                    position="top-right"
                    autoClose={1500}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    theme="dark"
                /> */}
            </Box>
        </Dialog >
    );
};

export default UserReferralSchemeModal;
